import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { callPymbleApi } from "./usePymbleApi";

// S2 endpoint — notice admin search
const NOTICE_END_POINT = "notice/admin/";

/**
 * Hook to search notices via S2 API.
 * Manually triggered (not auto-fetch), so uses callPymbleApi directly.
 */
export function useNoticeManager() {
	const [notices, setNotices] = useState<unknown[]>([]);
	const [noticesLoaded, setNoticesLoaded] = useState(false);
	const { instance } = useMsal();

	// Load the data
	const getData = async (searchText: string) => {
		setNoticesLoaded(false);
		const endpoint = NOTICE_END_POINT + "?title=" + searchText;

		const res = await callPymbleApi(instance, "GET", endpoint);
		if (res) {
			const items = Array.isArray(res) && res[0]?.data ? res[0].data : res;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const sortedNotices = items.sort((a: any, b: any) =>
				a.Title.localeCompare(b.Title)
			);
			setNotices(sortedNotices);
			setNoticesLoaded(true);
			return sortedNotices;
		}
	};

	return {
		getData,
		notices,
		noticesLoaded,
	};
}
